import { createAsyncThunk } from "@reduxjs/toolkit";
import { getErrorPayload } from "@application/common/helpers/api-helper";
import brandApi from "@infrastructure/brand-api";
export const getAllBrandsAsync = createAsyncThunk('Merk/GetAll', async (_, { rejectWithValue }) => {
    try {
        const response = await brandApi.getAllBrands();
        return response.data;
    }
    catch (error) {
        return rejectWithValue(getErrorPayload(error));
    }
});
